import { z } from 'zod'
import { t } from 'i18next'
import { Betriebsstellenart } from '../../../../types'
import {
  ZugmeldestelleNameSchema,
  ZugmeldestelleSchema
} from '../../Generic/schema/generic.schema'
import {
  ETCS_EINFAHRWEICHE_MAX_LENGTH,
  ETCS_EINFAHRWEICHE_REGEXP,
  UHRZEIT_MAX_LENGTH,
  UHRZEIT_REGEXP
} from '../../../../utils'
import { allowedChars } from '../../../../utils/customValidationMessage'

// Default constants
const DEFAULT_ZUGMELDESTELLE = {
  art: '' as const,
  name: ''
}

const DEFAULT_FELD31_11_12 = {
  selector: '' as const,
  name: ''
}

const DEFAULT_AUFTRAG_31_10 = {
  enabled: true,
  feld31_11_12: DEFAULT_FELD31_11_12,
  feld31_13: DEFAULT_ZUGMELDESTELLE,
  feld31_17: ''
}

const DEFAULT_BEFEHL_31_FORM = {
  auftrag_31_10: DEFAULT_AUFTRAG_31_10,
  auftrag31_14: false,
  auftrag31_15: false,
  feld31_16: ''
}

// Schema definitions
const Feld31_11_12Schema = z
  .object({
    selector: z
      .enum(['', Betriebsstellenart.Bf, Betriebsstellenart.Bft])
      .default(DEFAULT_FELD31_11_12.selector),
    name: ZugmeldestelleNameSchema
  })
  .default(() => structuredClone(DEFAULT_FELD31_11_12))

const Auftrag31_10Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_31_10.enabled),
    feld31_11_12: Feld31_11_12Schema,
    feld31_13: ZugmeldestelleSchema.default(DEFAULT_AUFTRAG_31_10.feld31_13),
    feld31_17: z
      .string()
      .max(UHRZEIT_MAX_LENGTH)
      .superRefine(allowedChars(UHRZEIT_REGEXP))
      .default(DEFAULT_AUFTRAG_31_10.feld31_17)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_31_10))

// Base schema
const Befehl31FormSchemaBase = z
  .object({
    auftrag_31_10: Auftrag31_10Schema,
    auftrag31_14: z.boolean().default(DEFAULT_BEFEHL_31_FORM.auftrag31_14),
    auftrag31_15: z.boolean().default(DEFAULT_BEFEHL_31_FORM.auftrag31_15),
    feld31_16: z
      .string()
      .max(ETCS_EINFAHRWEICHE_MAX_LENGTH)
      .superRefine(allowedChars(ETCS_EINFAHRWEICHE_REGEXP))
      .default(DEFAULT_BEFEHL_31_FORM.feld31_16)
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_31_FORM))

export const Befehl31FormSchema = Befehl31FormSchemaBase

// Validation schema
export const createBefehl31FormValidationSchema = () =>
  Befehl31FormSchema.refine(
    (data) => {
      return data.auftrag31_14 || data.auftrag31_15
    },
    {
      message: t('ui-validation:befehl31.select_one')
    }
  )

export type Befehl31FormData = z.infer<typeof Befehl31FormSchemaBase>
